import { ApiConcept } from 'types/swagger/clarifai-api';
import { fetchAllConceptsByName } from 'api-proxy/private/findConceptsByName';

type AiConcept = {
  id: string;
  name: string;
  appId: string;
  userId: string;
};

type Request = {
  userOrOrgId: string;
  appId: string;
};

type GetApiConceptsRequest = {
  request: Request;
  aiConcept: AiConcept;
};

type GetApiConceptsResponse = {
  apiAiConcept?: ApiConcept | undefined;
  apiAppConcept?: ApiConcept | undefined;
};

type FindApiAiConceptProps = {
  concepts?: ApiConcept[] | null | undefined;
  aiConcept: AiConcept;
};

type FindApiAppConceptProps = {
  concepts?: ApiConcept[] | null | undefined;
  request: Request;
};

const _findApiAiConcept = ({ concepts, aiConcept }: FindApiAiConceptProps): ApiConcept | undefined => {
  // Concept By Id has highest priority, as we cannot have multiple concepts with same id
  const conceptById = concepts?.find((c) => c?.id && c.id === aiConcept.id);
  if (conceptById) return conceptById;

  return concepts?.find((c) => c?.app_id && c?.user_id && c.app_id === aiConcept.appId && c.user_id === aiConcept.userId);
};

const _findCurrentAppConcept = ({ concepts, request }: FindApiAppConceptProps): ApiConcept | undefined =>
  concepts?.find((c) => c.app_id === request.appId && c.user_id === request.userOrOrgId);

export const getApiConcepts = async ({ request, aiConcept }: GetApiConceptsRequest): Promise<GetApiConceptsResponse> => {
  const concepts = await fetchAllConceptsByName({
    request,
    conceptName: aiConcept.name,
    onlyCurrentAppConcepts: false,
  });

  // Existing AI concept on BackEnd
  const apiAiConcept = _findApiAiConcept({ concepts, aiConcept });

  // Existing APP concept on BackEnd
  const apiAppConcept = _findCurrentAppConcept({ concepts, request });

  return {
    apiAiConcept,
    apiAppConcept,
  };
};
